import { LoadState } from "../../constants/enums";
import { 
    ICallingState, 
    ICallCampaign, 
    ICallCampaignData, 
    IAssignToLeadPayload, 
    IAssignToAgentPayload,
    IBulkCallCampaign,
} from "./calling.types";

/**
 * Initial object for a single Call Campaign
 * Derived from Swagger POST /api/v1/calling/upsert-call-campaign
 */
export const initialCallCampaign: ICallCampaign = {
    call_campaign_uuid: "",
    call_campaign_name: "",
    campaign_data_type: "",
    status: "ACTIVE",
    company_outlet_uuid: "",

    // Assignment details
    assigned_to_uuid: "",
    assigned_to_name: "",

    // Linked Lead details
    lead_uuid: "",
    lead_name: "",

    comment: "",

    // Read-only metadata
    created_by_uuid: "",
    created_by_name: "",
    modified_by_uuid: "",
    modified_by_name: "",
    create_ts: "",
    insert_ts: ""
};

/**
 * Initial object for a single Call Campaign Data record
 * Derived from Swagger POST /api/v1/calling/upsert-call-campaign-data
 */
export const initialCallCampaignData: ICallCampaignData = {
    call_campaign_data_uuid: "",
    call_campaign_uuid: "",
    call_campaign_name: "",

    // Customer & Membership Details
    membership_code: "",
    customer_name: "",
    vehicle_number: "",
    phone_res: "",
    phone_off: "",
    contact_number: "",
    secondary_contact_number: "",
    email: "",

    // Address & Region
    address: "",
    city: "",
    state: "",
    pin_code: "",

    // Membership Dates
    registration_year: "",
    membership_start_date: "",
    membership_expiry_date: "",

    // Calling Logic & Disposition
    next_day_call: "",
    next_day_call_time: "",
    scheduled_call_date: "",
    call_disposition: "",
    dnd_flag: 0, 
    interested_flag: 0, 

    // Meta data
    data_type: "",
    category: "",
    comment: "",
    status: "ACTIVE",
    company_outlet_uuid: "",

    // Read-only metadata
    created_by_uuid: "",
    modified_by_uuid: "",
    create_ts: "",
    insert_ts: "",
};

/**
 * Initial object for Bulk Campaign tracking
 * Derived from Swagger POST /api/v1/calling/insert-bulk-call-campaign
 */
export const initialBulkCallCampaign: IBulkCallCampaign = {
    bulk_campaign_unique_id: 0,
    bulk_campaign_uuid: "",
    campaign_name: "",
    file_name: "",
    total_records: 0,
    upload_status: "PENDING",
    company_outlet_uuid: "",
    created_by_name: "",
    create_ts: "",
};

/**
 * Initial payload for assigning data to a lead
 */
export const initialAssignToLeadPayload: IAssignToLeadPayload = {
    call_campaign_data_uuid: "",
    call_campaign_uuid: "",
    lead_uuid: "",
    lead_name: ""
};

/**
 * Initial payload for assigning data to an agent
 */
export const initialAssignToAgentPayload: IAssignToAgentPayload = {
  call_campaign_data_uuid: "",
  call_campaign_uuid: "",
  agent_uuid: "",
  assigned_to_name: "",
  assigned_to_uuid: "",
};

/**
 * Main Calling Module Initial Store State
 * Matches the structure of IPartnersState
 */
export const InitialCallingState: ICallingState = {
    callCampaign: {
        list: {
            list: [],
            totalRecords: 0,
            loading: LoadState.NotLoaded,
            error: null,
        },
        data: {
            data: initialCallCampaign,
            loading: LoadState.NotLoaded,
            error: null,
        },
    },
    callCampaignData: {
        list: {
            list: [],
            totalRecords: 0,
            loading: LoadState.NotLoaded,
            error: null,
        },
        data: {
            data: initialCallCampaignData,
            loading: LoadState.NotLoaded,
            error: null,
        },
    },
    bulkCampaign: {
        list: {
            list: [],
            totalRecords: 0,
            loading: LoadState.NotLoaded,
            error: null,
        },
        data: {
            data: initialBulkCallCampaign,
            loading: LoadState.NotLoaded,
            error: null,
        },
    },
    assignmentStatus: {
        loading: LoadState.NotLoaded,
        error: null,
    }
};